import React from 'react';
import Breadcrumb from '../../../components/Breadcrumb';
import { SOCIETY_EMPLOYEE_TYPES } from '../../../Routing/routes';
import EmployeeTypesListLayer from './Component/EmployeeTypesListLayer';

const EmployeeTypes = () => {
    const links = [{ to: SOCIETY_EMPLOYEE_TYPES, text: 'Employee Types' }];
    return (
        <>
            <Breadcrumb
                replaceClass="mb-24"
                description="Manage the global employee-type catalog"
                links={links}
                headingTitle="Employee Types"
            />
            <EmployeeTypesListLayer />
        </>
    );
};

export default EmployeeTypes;
